<template>
  <path
    d="M4 19.0002H20C20.55 19.0002 21 18.5502 21 18.0002V14.0002C21 13.4502 20.55 13.0002 20 13.0002H4C3.45 13.0002 3 13.4502 3 14.0002V18.0002C3 18.5502 3.45 19.0002 4 19.0002ZM4 11.0002H20C20.55 11.0002 21 10.5502 21 10.0002C21 9.45018 20.55 9.00018 20 9.00018H4C3.45 9.00018 3 9.45018 3 10.0002C3 10.5502 3.45 11.0002 4 11.0002ZM3 6.00018C3 6.55018 3.45 7.00018 4 7.00018H20C20.55 7.00018 21 6.55018 21 6.00018C21 5.45018 20.55 5.00018 20 5.00018H4C3.45 5.00018 3 5.45018 3 6.00018Z"
  />
</template>
